import axios from 'axios';
import { store } from 'app/store';
import { gmcRefDatasetSearch, hcpcRefDatasetSearch } from 'util/request-creator';

class Api {
    constructor() {
        const config = store.getState().config;

        this.baseUrl = config.apiBaseUrl;
        this.collection = this.getCollectionUrlSlug();
    }

    getCollection() {
        const path = `v2/collection/${this.collection}`;
        const url = new URL(path, this.baseUrl);

        return axios({
            method: 'get',
            url: url,
            headers: getHeaders()
        });
    }

    async getUserOrgCollection() {
        const path = `/v2/collections`;
        const url = new URL(path, this.baseUrl);

        return axios({
            method: 'get',
            url: url,
            headers: getHeaders()
        });
    }

    async getOrganisations() {
        const path = `v2/organisations/${this.collection}`;
        const url = new URL(path, this.baseUrl);

        const response = await axios({
            method: 'get',
            url: url,
            headers: getHeaders()
        });

        return response.data;
    }

    getCollectionUrlSlug() {
        const url = new URL(window.location.href);

        return url.pathname.split('/')[1];
    }

    async getIdentityProviders() {
        const path = 'v2/auth/identity-providers';
        const url = new URL(path, this.baseUrl);

        return axios({
            method: 'get',
            url: url
        });
    }

    getSubmissions(orgCode, formatSubmissions) {
        const path = `v2/submissions/${this.collection}?orgCode=${orgCode}&format=${formatSubmissions}`;
        const url = new URL(path, this.baseUrl);

        return axios({
            method: 'get',
            url: url,
            headers: getHeaders()
        });
    }

    async getSubmission(submissionId) {
        const path = `v2/submission/${this.collection}/${submissionId}/in-progress`;
        const url = new URL(path, this.baseUrl);

        const response = await axios({
            method: 'get',
            url: url,
            headers: getHeaders()
        });

        return response.data;
    }

    postSubmission(section) {
        const path = `v2/submission/${this.collection}`;
        const url = new URL(path, this.baseUrl);

        return axios({
            method: 'post',
            url: url,
            data: section,
            headers: getHeaders()
        });
    }

    async deleteSubmission(submissionId, deleteReason) {
        const path = `v2/submission/${this.collection}/${submissionId}`;
        const url = new URL(path, this.baseUrl);

        return axios.delete(url, {
            data: deleteReason,
            headers: getHeaders()
        });
    }

    async transferSubmission(submissionId, payload) {
        const path = `v2/submission/${this.collection}/${submissionId}/transfer`;
        const url = new URL(path, this.baseUrl);

        const response = await axios({
            method: 'post',
            url: url,
            data: payload,
            headers: getHeaders()
        });
        return response.data;
    }

    patchSubmission(section, id) {
        const path = `v2/submission/${this.collection}/${id}`;
        const url = new URL(path, this.baseUrl);
        return axios({
            method: 'patch',
            url: url,
            data: section,
            headers: getHeaders()
        });
    }

    async putSubmission(sections, id) {
        const path = `v2/submission/${this.collection}/${id}`;
        const url = new URL(path, this.baseUrl);

        const response = await axios({
            method: 'put',
            url: url,
            data: sections,
            headers: getHeaders()
        });
        return response.data;
    }

    deleteSubmissionSection(id, sectionId, index) {
        const path = `v2/submission/${this.collection}/${id}/${sectionId}/${index}`;
        const url = new URL(path, this.baseUrl);

        return axios({
            method: 'delete',
            url: url,
            headers: getHeaders()
        });
    }

    getGMCRefData(query) {
        const path = `v2/ref-data/gmc?query=${query}`;
        const url = new URL(path, this.baseUrl);
        const { accessToken } = store.getState().auth;
        return gmcRefDatasetSearch(url, accessToken);
    }

    getHCPCRefData(query) {
        const path = `v2/ref-data/hcpc?query=${query}`;
        const url = new URL(path, this.baseUrl);
        const { accessToken } = store.getState().auth;

        return hcpcRefDatasetSearch(url, accessToken);
    }

    async postAuditLog(orgCode, collectionName, auditMessage) {
        const path = `v2/audit-logger`;
        const url = new URL(path, this.baseUrl);
        const data = {
            orgCode: orgCode,
            collectionName: collectionName,
            auditMessage: auditMessage,
            methodType: 'POST'
        };

        const response = await axios({
            method: 'POST',
            url: url,
            data: data,
            headers: getHeaders()
        });

        return response;
    }

    async getLatestLoginLog(orgCode, collectionName, auditMessage) {
        const path = `v2/audit-logger`;
        const url = new URL(path, this.baseUrl);

        const data = {
            orgCode: orgCode,
            collectionName: collectionName,
            auditMessage: auditMessage,
            methodType: 'GET'
        };

        const response = await axios({
            method: 'POST',
            url: url,
            data: data,
            headers: getHeaders()
        });

        return response;
    }
}

function getHeaders() {
    const { accessToken } = store.getState().auth;

    return {
        Authorization: `Bearer ${accessToken}`
    };
}

export default Api;
